import { api, unwrap } from './client';
import { getRefreshToken } from '../lib/authStorage';

export { ApiError } from './client';

async function get(path, params) {
  const res = await api.get(path, { params });
  return unwrap(res.data);
}

async function post(path, body) {
  const res = await api.post(path, body);
  return unwrap(res.data);
}

async function patch(path, body) {
  const res = await api.patch(path, body);
  return unwrap(res.data);
}

async function del(path) {
  const res = await api.delete(path);
  return res.status === 204 ? null : unwrap(res.data);
}

export const loginAdmin = (payload) => post('/v1/admin/auth/login', payload);
export const logoutAdmin = () =>
  post('/v1/admin/auth/logout', { refreshToken: getRefreshToken() || undefined });
export const fetchMe = () => get('/v1/admin/auth/me');
export const refreshAdminToken = () =>
  post('/v1/admin/auth/refresh', { refreshToken: getRefreshToken() || undefined });
export const forgotPassword = (payload) => post('/v1/admin/auth/forgot-password', payload);
export const resetPassword = (payload) => post('/v1/admin/auth/reset-password', payload);

export const fetchDashboardCounts = () => get('/v1/admin/dashboard');

export const listBrands = (params) => get('/v1/admin/brands', params);
export const getBrand = (id) => get(`/v1/admin/brands/${id}`);
export const createBrand = (body) => post('/v1/admin/brands', body);
export const updateBrand = (id, body) => patch(`/v1/admin/brands/${id}`, body);
export const resetBrandPassword = (id, body) => post(`/v1/admin/brands/${id}/reset-password`, body);
export const grantBrandQuota = (id, body) => post(`/v1/admin/brands/${id}/quota/grants`, body);
export const listBrandQuotaLedger = (id, params) => get(`/v1/admin/brands/${id}/quota/ledger`, params);
export const getBrandQuotaSummary = (id) => get(`/v1/admin/brands/${id}/quota/summary`);
export const deleteBrand = (id) => del(`/v1/admin/brands/${id}`);

export const listCoupons = (params) => get('/v1/admin/coupons', params);
export const getCoupon = (id) => get(`/v1/admin/coupons/${id}`);
export const generateCoupons = (body) => post('/v1/admin/coupons/generate', body);
export const updateCoupon = (id, body) => patch(`/v1/admin/coupons/${id}`, body);
export const deleteCoupon = (id) => del(`/v1/admin/coupons/${id}`);

export const listVerifications = (params) => get('/v1/admin/verifications', params);
export const getVerification = (id) => get(`/v1/admin/verifications/${id}`);

export const fetchSettings = () => get('/v1/admin/settings');
export const updateSettings = (body) => patch('/v1/admin/settings', body);
export const changePassword = (body) => post('/v1/admin/settings/change-password', body);
